<template>
  <div class="lyear-layout-web">
    <div class="lyear-layout-container">
      <!--左侧导航-->
      <user-left></user-left>
      <!--End 左侧导航-->
      
      <!--头部信息-->
      <user-head></user-head>
      <!--End 头部信息-->
      
      <!--页面主要内容-->
      <main class="lyear-layout-content">
        
        <div class="container-fluid">
          
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-toolbar clearfix">
                  <form class="pull-right search-bar" method="get" action="#!" role="form">
                    <div class="input-group">
<!--                      <div class="input-group-btn">
                        <input type="hidden" name="search_field" id="search-field" value="title">
                        <button class="btn btn-default dropdown-toggle" id="search-btn" data-toggle="dropdown" type="button" aria-haspopup="true" aria-expanded="false">
                        标题 <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu">
                          <li> <a tabindex="-1" href="javascript:void(0)" data-field="title">标题</a> </li>
                          <li> <a tabindex="-1" href="javascript:void(0)" data-field="cat_name">栏目</a> </li>
                        </ul>
                      </div>
                      <input type="text" class="form-control" value="" name="keyword" placeholder="请输入名称"> -->
                    </div>
                  </form>
                  <div class="toolbar-btn-action">
                    <!-- <a class="btn btn-primary m-r-5" href="#!"><i class="mdi mdi-plus"></i> 全部</a> -->
                    <div class="btn btn-danger" @click="delete1 = true"><i class="mdi mdi-window-close"></i> 删除</div>
                  </div>
                </div>
                <div class="card-body">
                  
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>
                            <!-- <label class="lyear-checkbox checkbox-primary">
                              <input type="checkbox"  @change="changeCheck(item.id)"><span></span>
                            </label> -->
                          </th>
                          <th>编号</th>
                          <th>名称</th>
                          <th>类型</th>
                          <th>作者</th>
                          <th>下载量</th>
                          <th>状态</th>
                          <th>操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item,index in collectlist" :key="index">
                          <td>
                            <label class="lyear-checkbox checkbox-primary">
                              <input type="checkbox" :checked="ischeck" @change="changeCheck(item.id)"><span></span>
                            </label>
                          </td>
                          <td>{{index + 1}}</td>
                          <td class="shou" @click="enterDetail(item.docId, item.docLibId)">{{item.docName}}</td>
                          <td>{{item.doclibName}}</td>
                          <td>{{item.sysAuthors}}</td>
                          <td>{{item.uoload}}</td>
                          <td><font class="text-success">正常</font></td>
                          <td>
                            <div class="btn-group">
                              <!-- <a class="btn btn-xs btn-default" href="#!" title="编辑" data-toggle="tooltip"><i class="mdi mdi-pencil"></i></a> -->
                              <div @click="collectDel(item.id)" class="btn btn-xs btn-default" href="#!" title="删除" data-toggle="tooltip"><i class="mdi mdi-window-close"></i></div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                 <!-- 分页器 -->
									<div class="pagination">
										<Page class-name="page-class" :total="total" :page-size="10" @on-change="changePage" />
									</div>
         
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
        
      </main>
      <!--End 页面主要内容-->
    </div>
		
		<Modal
				v-model="delete1"
				title="友情提示"
				@on-ok="collectDel"
				@on-cancel="">
				<p>是否确认删除选中的投稿列表</p>
		</Modal>
  </div>
</template>

<script>
import userLeft from './user_left.vue'
import userHead from './user_head.vue'
export default {
  data () {
    return {
			collectlist: [],
			total: 0,
			delId:[],
			delete1: false,
			ischeck: false
		}
  },

	components: {
		userLeft,
		userHead
	},
	
  created () {},
	
	mounted () {
		this.collectList1()
	},

  methods: {
		// 获取收藏列表
		async collectList1 (page=1) {
			let _this = this
			_this.$Spin.show()
			let data = {
				pageNumber:page,
				pageSize:10,
			}
			const res = await _this.get_res('/members/wlcollects', data)
			if (res) {
			 res.content.forEach( async (x,index) => {
					const uploadCount_res = await this.util.uoloadCount(x.docId)
					x.uoload = uploadCount_res.downloadsnum
				})
				setTimeout( () => {
					_this.ischeck = false
					_this.collectlist = res.content
					_this.total = res.totalElements
					_this.$Spin.hide()
				},500)
			}
		},
		
		changePage (page) {
			this.downrecord(page)
		},
		
		changeCheck (id) {
			// console.log(id)
			let _this = this
			if (_this.delId.includes(id)) {
				let index = _this.delId.findIndex(x =>  x==id)
				_this.delId.splice(index,1)
			} else {
				_this.delId.push(id)
			}
		},
		
		// 批量删除收藏
		async collectDel (id = 0) {
			let _this = this
			if (id) {
				const res = await _this.delete_api('/members/collects?delId=' + id)
				_this.ischeck = false
				_this.$Message.success({
					content: '删除成功'
				})
			} else {
				if (!_this.delId.length) {
					return _this.$Message.error({
						content: '请选择相应的收藏资源'
					})
				}
				const res = await _this.delete_api('/members/collects?delId=' + _this.delId)
				_this.ischeck = false
				_this.$Message.success({
					content: '删除成功'
				})
			}
			
			window.location.reload()
			// _this.collectList()
		},
		
		// 跳转
		enterDetail (id,tid) {
				if (tid == 25 || tid == 837) {
					let link = this.$router.resolve({path:'/img_detail',query: {id,tid}})
					window.open(link.href, "_blank")
				} else if (tid == 28) {
					let link = this.$router.resolve({path:'/audio_detail',query: {id,tid}})
					window.open(link.href, "_blank")
				} else {
					let link = this.$router.resolve({path:'/video_detail',query: {id,tid}})
					window.open(link.href, "_blank")
				}
		},
		
	}
}
</script>

<style lang="less" scoped>
th,td {
	text-align: center;
}
</style>
